import React from 'react';
import { motion } from 'framer-motion';

export const ProductCardSkeleton = () => (
  <div className="w-full animate-pulse">
    <div className="aspect-[3/4] bg-gray-200 mb-5 w-full rounded-sm"></div>
    <div className="px-2 space-y-3">
      <div className="flex justify-between items-center">
        <div className="h-6 bg-gray-200 rounded w-2/3"></div>
        <div className="h-5 bg-gray-200 rounded w-1/4"></div>
      </div>
      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
    </div>
  </div>
);

export const ProductDetailSkeleton = () => (
  <div className="container mx-auto px-6 md:px-12 py-12">
    <div className="h-4 bg-gray-200 rounded w-48 mb-12 animate-pulse"></div>
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
      <div className="lg:col-span-7">
        <div className="bg-gray-100 aspect-square md:aspect-[4/5] animate-pulse rounded-sm"></div>
      </div>
      <div className="lg:col-span-5 flex flex-col pt-4 animate-pulse">
        <div className="h-3 bg-gray-200 rounded w-32 mb-4"></div>
        <div className="h-12 bg-gray-200 rounded w-3/4 mb-4"></div>
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-8"></div>
        <div className="h-10 bg-gray-200 rounded w-1/3 mb-10"></div>
        <div className="grid grid-cols-2 gap-4 mb-12">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="h-32 bg-gray-200 rounded"></div>
          ))}
        </div>
        <div className="h-16 bg-gray-200 rounded w-full"></div>
      </div>
    </div>
  </div>
);